import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import InfoIcon from "assets/icons/authPerson.svg?react";
import EmailIcon from "assets/icons/authMail.svg?react";
import IDIcon from "assets/icons/authSignature.svg?react";
import KeyIcon from "assets/icons/authKey.svg?react";
import UserDataIcon from "assets/icons/user_data.svg?react";

export enum ESteps {
  ACCOUNT_TYPE,
  INFORMATION,
  EMAIL_VERIFICATION,
  ID_VERIFICATION,
  WELCOME_BACK,
  KEY_GENERATION,
  COMPANY_DATA,
  COMPANY_DATA_VERIFICATION,
}

const getIcon = (type: ESteps) => {
  switch (type) {
    case 0:
    case ESteps.INFORMATION:
      return <InfoIcon />;
    case ESteps.EMAIL_VERIFICATION:
      return <EmailIcon />;
    case ESteps.ID_VERIFICATION:
      return <IDIcon />;
    case ESteps.KEY_GENERATION:
      return <KeyIcon />;
    case ESteps.WELCOME_BACK:
      return <InfoIcon />;
    case ESteps.COMPANY_DATA:
      return <UserDataIcon />;
    default:
      return <InfoIcon />;
  }
};

const Stepper: FC<Props> = ({ steps, actualStep }) => {
  // const actualStep = ESteps.INFORMATION;

  // const steps = [
  //   {
  //     type: ESteps.INFORMATION,
  //     title: 'Twoje dane',
  //     text: 'Wpisz email i hasło bądź wybierz metodę logowania',
  //   },
  //   {
  //     type: ESteps.EMAIL_VERIFICATION,
  //     title: 'Weryfikacja adresu email',
  //     text: 'Wpisz kod weryfikujący',
  //   },
  //   {
  //     type: ESteps.ID_VERIFICATION,
  //     title: 'Weryfikacja tożsamości',
  //     text: 'Wybierz sposób weryfikacji',
  //   },
  //   {
  //     type: ESteps.KEY_GENERATION,
  //     title: 'Klucz przywracania',
  //     text: 'Generuj Swój klucz przywracania',
  //   },
  // ];

  return (
    <div className={styles.wrapper}>
      {steps.map((step, index) => {
        const isActive = actualStep === step.type;

        if (step.hidden) {
          return <></>;
        }

        return (
          <div className={styles.wrap} key={"stepper_step" + index}>
            <div className={`${styles.card} ${isActive && styles.active}`}>
              <div className={`${styles.box}`}>{getIcon(step.type)}</div>
              <div className={styles.info}>
                <div className={styles.title}>{step.title}</div>
                <div className={styles.body}>{step.text}</div>
              </div>
            </div>
            {index < steps.length - 1 && <div className={styles.line}></div>}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
